import { useMutation, useQuery } from "@tanstack/react-query";
import { DepartmentsAPI } from "../api";

export const useGetAllDepartments = () => {
  return useMutation({
    mutationFn: () => DepartmentsAPI.getAll(),
    onError: (error) => {
      console.error("Get All Departments Failed: ", error.response || error);
    },
  });
};
export const useGetAllDepartmentsPaginated = ({
  page,
  pageSize,
  filterField1 = null,
  filterValue1 = null,
  filterField2 = null,
  filterValue2 = null,
}) => {
  return useQuery({
    queryKey: [
      "get-all-departments",
      page,
      pageSize,
      filterField1,
      filterValue1,
      filterField2,
      filterValue2,
    ],
    queryFn: () => {
      const obj = { page, pageSize };

      if (filterField1 && filterValue1) {
        obj.filterField1 = filterField1;
        obj.filterValue1 = filterValue1;
      }

      if (filterField2 && filterValue2) {
        obj.filterField2 = filterField2;
        obj.filterValue2 = filterValue2;
      }

      return DepartmentsAPI.getAllPaginated(obj);
    },
    onError: (error) => {
      console.error("Get All Departments Failed: ", error.response || error);
    },
  });
};

export const useGetDepartmentById = (id) => {
  return useQuery({
    queryKey: ["get-departments-by-id", id],
    queryFn: () => DepartmentsAPI.getById(id),
    enabled: !!id,
    onError: (error) => {
      console.error("Get Department By ID Failed: ", error.response || error);
    },
  });
};

export const _useGetDepartmentById = () => {
  return useMutation({
    mutationFn: (id) => DepartmentsAPI.getById(id),
    onError: (error) => {
      console.error("Get Department By ID Failed: ", error.response || error);
    },
  });
};

export const useCreateDepartment = () => {
  return useMutation({
    mutationFn: (payload) => DepartmentsAPI.create(payload),
    onError: (error) => {
      console.error("Create Department Failed: ", error.response || error);
    },
  });
};

export const useUpdateDepartment = () => {
  return useMutation({
    mutationFn: ({ id, payload }) => DepartmentsAPI.update({ id, payload }),
    onError: (error) => {
      console.error("Update Department Failed: ", error.response || error);
    },
  });
};

export const useDeleteDepartment = () => {
  return useMutation({
    mutationFn: (id) => DepartmentsAPI.delete(id),
    onError: (error) => {
      console.error("Delete Department Failed: ", error.response || error);
    },
  });
};
